// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Dashboard_PegaDadosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /dashboards/dashboard/pega_dados
 *
 * No body required — dashboard aggregates data using the session filter.
 */
import { registerContract } from './validate'

export interface Dashboard_PegaDadosInput {}

registerContract('Dashboard_PegaDadosInput', {})
